import { Pipe, PipeTransform } from '@angular/core';
import round from 'lodash-es/round';

@Pipe({
    name: 'liebherrFormatFileSize',
})
export class FormatFileSizePipe implements PipeTransform {
    constructor() {}

    transform(size: number) {
        return this.formatSize(size);
    }

    private formatSize(size: number) {
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        // Mac uses Base-10 to count file sizes others use Base-2
        const standardFactor = 1024;
        const macFactor = 1000;
        let standardValue = size;
        let macValue = size;
        let standardIdx = 0;
        let macIdx = 0;

        // get standard value
        while (standardValue > standardFactor) {
            standardValue = standardValue / standardFactor;
            standardIdx++;
        }
        // get mac value
        while (macValue > macFactor) {
            macValue = macValue / macFactor;
            macIdx++;
        }
        const formatted = round(standardValue, 1) + ' ' + units[standardIdx];
        return formatted;
    }
}
